// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, func, string } from 'prop-types'
import PathReportExport from 'components/PathReportExport'

const ModalTemplates = props => {
  const {
    allRowsHighlighted,
    closeModal,
    highlightedRows,
    idRoot,
    modalTemplate,
    sourceForm,
  } = props

  if (modalTemplate === 'export-report') {
    return (
      <PathReportExport
        allRowsHighlighted={allRowsHighlighted}
        closeModal={closeModal}
        dataSource={'paths'}
        highlightedRows={highlightedRows}
        idRoot={idRoot}
        sourceForm={sourceForm} />
    )
  }

  return (
    <div>
      {`Warning: unmapped modal template of ${modalTemplate}`}
    </div>
  )
}

ModalTemplates.propTypes = {
  allRowsHighlighted: bool.isRequired,
  closeModal: func.isRequired,
  highlightedRows: array.isRequired,
  idRoot: string.isRequired,
  modalTemplate: string.isRequired,
  sourceForm: string.isRequired,
}

export default ModalTemplates
